// @flow
import _ from 'underscore';

export const DEFAULT_ERROR_MESSAGE = 'Unknown network error occurred.';
export const EXPIRED_TOKEN_MESSAGE = 'expired_token';

class RequestError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export default function getError(err: Object, requestUrl: string) {
  let errorMessage;
  const hasErrors = err && err.errors;
  const errors = hasErrors ? err.errors : null;

  if (errors) {
    errorMessage = _.map(errors, (_err) => {
      const attr = _err.attribute ? `${_err.attribute}:` : '';
      const message = _err.message || _err;

      return `${attr} ${message}`;
    }).join('; ');
  } else if (err.error) {
    errorMessage = _.map(err.error, _err => {
      if (typeof _err !== 'number') {
        return _err;
      } else {
        return '';
      }
    }).join('');
  } else {
    errorMessage = DEFAULT_ERROR_MESSAGE;
  }

  const error = new RequestError(errorMessage, err.status);
  /* eslint-disable */
  console.info('Failed request: ', requestUrl);
  /* eslint-enable */
  return error;
}